/* ak-muji-tie LP - minimal */
(function(){
  // smooth scroll for in-page anchors
  document.addEventListener('click', function(e){
    const a = e.target.closest('a[href^="#"]');
    if(!a) return;
    const id = a.getAttribute('href');
    const el = document.querySelector(id);
    if(!el) return;
    e.preventDefault();
    el.scrollIntoView({behavior:'smooth', block:'start'});
  });
})();

/* =========================================================
  03v2: HERO swipe slider + thumbs sync (FINAL, single source of truth)
  - scope: only inside [data-aklp-block="edu03v2"]
  - thumbs click -> scroll track
  - swipe/scroll -> update is-active
========================================================= */
(function(){
  function getIndexFromScroll(track){
    const w = track.clientWidth || 1;
    return Math.max(0, Math.round(track.scrollLeft / w));
  }

  function setActive(block, index){
    block.querySelectorAll('[data-aklp-thumb]').forEach(t => t.classList.remove('is-active'));
    const hit = block.querySelector(`[data-aklp-thumb][data-slide="${index}"]`);
    if(hit) hit.classList.add('is-active');
  }

  function scrollToIndex(track, index){
    const x = Math.round(track.clientWidth * index);
    track.scrollTo({ left: x, behavior: 'smooth' });
  }

  // thumbs click -> scroll
  document.addEventListener('click', function(e){
    const thumb = e.target.closest('[data-aklp-thumb]');
    if(!thumb) return;

    const block = thumb.closest('[data-aklp-block="edu03v2"]');
    if(!block) return;

    const track = block.querySelector('[data-aklp-track]');
    if(!track) return;

    const index = parseInt(thumb.getAttribute('data-slide') || '0', 10);
    scrollToIndex(track, index);
    setActive(block, index);
  });

  // swipe/scroll -> update active (rAF debounce)
  const rafLock = new WeakMap();

  document.addEventListener('scroll', function(e){
    const track = e.target;
    if(!track || !track.matches || !track.matches('[data-aklp-track]')) return;

    const block = track.closest('[data-aklp-block="edu03v2"]');
    if(!block) return;

    if(rafLock.get(track)) return;
    rafLock.set(track, true);

    requestAnimationFrame(function(){
      const index = getIndexFromScroll(track);
      setActive(block, index);
      rafLock.set(track, false);
    });
  }, true);

  // initial sync on load (in case not at 0)
  window.addEventListener('load', function(){
    document.querySelectorAll('[data-aklp-block="edu03v2"]').forEach(function(block){
      const track = block.querySelector('[data-aklp-track]');
      if(!track) return;
      setActive(block, getIndexFromScroll(track));
    });
  });
})();

(function(){
  const state = {
    A: { ties: [null, null, null] },
    B: { tie: null, chief: null }
  };

  function setButtonState(){
    document.querySelectorAll('.js-add').forEach(btn=>{
      const camp = btn.dataset.camp;
      if(camp === 'A'){
        btn.disabled = !state.A.ties.every(Boolean);
      }else{
        btn.disabled = !(state.B.tie && state.B.chief);
      }
    });
  }

  document.addEventListener('change', (e)=>{
    const sel = e.target.closest('.js-variant');
    if(!sel) return;

    const camp = sel.dataset.camp;
    const role = sel.dataset.role;
    const index = parseInt(sel.dataset.index || '0', 10);

    if(camp === 'A' && role === 'tie'){
      state.A.ties[index] = sel.value || null;
    }
    if(camp === 'B'){
      if(role === 'tie') state.B.tie = sel.value || null;
      if(role === 'chief') state.B.chief = sel.value || null;
    }
    setButtonState();
  });

  async function addItems(items){
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify({ items })
    });
    if(!res.ok) throw new Error('cart add failed');
    return res.json();
  }

  async function refreshCartDrawerAndOpen(){
    const sectionsToRender = 'cart-drawer,cart-icon-bubble';
    const sectionsUrl = `${window.Shopify.routes.root}?sections=${sectionsToRender}`;

    const res = await fetch(sectionsUrl);
    const sections = await res.json();

    if (sections['cart-drawer']) {
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        const parser = new DOMParser();
        const newDoc = parser.parseFromString(sections['cart-drawer'], 'text/html');
        const newDrawerInner = newDoc.querySelector('.drawer__inner');
        const currentDrawerInner = cartDrawer.querySelector('.drawer__inner');
        if (newDrawerInner && currentDrawerInner) {
          currentDrawerInner.innerHTML = newDrawerInner.innerHTML;
        }
        cartDrawer.classList.remove('is-empty');
      }
    }

    if (sections['cart-icon-bubble']) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble) {
        const parser = new DOMParser();
        const newDoc = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
        const newBubble = newDoc.querySelector('.shopify-section');
        if (newBubble) cartIconBubble.innerHTML = newBubble.innerHTML;
      }
    }

    setTimeout(() => {
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.open === 'function') cartDrawer.open();
    }, 100);
  }

  document.addEventListener('click', async (e)=>{
    const btn = e.target.closest('.js-add');
    if(!btn) return;

    const camp = btn.dataset.camp;
    btn.disabled = true;

    try{
      let items = [];
      if(camp === 'A'){
        items = state.A.ties.map(id => ({ id, quantity: 1 }));
      }else{
        items = [{ id: state.B.tie, quantity: 1 }, { id: state.B.chief, quantity: 1 }];
      }

      await addItems(items);
      await refreshCartDrawerAndOpen();

      // 成功時の簡易フィードバック（任意）
      btn.textContent = '追加しました✓';
      setTimeout(()=>{
        btn.textContent = 'カートに追加';
        setButtonState();
      }, 1500);

    }catch(err){
      alert('カートへの追加に失敗しました');
      console.error(err);
      setButtonState();
    }
  });

  setButtonState();
})();
